import React, { Component } from 'react'
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";

class CheckInStepProgress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            progressPercent: 0,
        };
    }

    componentDidMount() {
        this.animateProgress();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentSelectVip !== this.props.currentSelectVip || prevProps.today !== this.props.today) {
            this.animateProgress();
        }

        if (prevProps.memberProgress?.firstUncheckedInDay !== this.props.memberProgress?.firstUncheckedInDay) {
            this.animateProgress();
        }
    }

    calculateProgress = () => {
        let n = this.props.memberProgress?.days?.findIndex(day => !day.isCheckedIn) || 0;
        if (n === -1) {
            // All days are checked in
            // Fill the entire progress bar
            return isDesktop ? 97 : 91; //
        }
        n = Math.max(0, n - 1);
        return isDesktop ? (n / 6) * 97 : (n / 6) * 91;
    };

    animateProgress = () => {
        this.setState({ progressPercent: 0 }, () => {

        setTimeout(() => {
            this.setState({ progressPercent: this.calculateProgress() });
        }, 50);
        });
    };

    renderIcon(day) {
        const { memberProgress, today, t } = this.props;

        if (day === 3) {
            return (
                <div>
                    {isDesktop ? (
                        <>
                            {day < today ? (
                                memberProgress.days[day].isCheckedIn ? 
                                    <img src={this.props.icon['giftbox-tick.svg']} alt='giftbox' height={65}/> 
                                    : 
                                    <img src={this.props.icon['giftbox.webp']} alt='giftbox' height={65}/> 
                            ): 
                                !memberProgress.days[day].isCheckedIn && 
                                    <img src={this.props.icon['giftbox.webp']} alt='giftbox' height={65}/> 
                            }

                            {day === today && 
                                memberProgress.days[day].isCheckedIn && 
                                <img src={this.props.icon['giftbox-tick.svg']} alt='giftbox' height={65}/> 
                            }                           
                        </>
                    ) : (
                        <>
                            {day < today ? (
                                memberProgress.days[day].isCheckedIn ? 
                                    <img src={this.props.icon['giftbox-tick.svg']} alt='giftbox' height={90} width={100}/> 
                                    : 
                                    <img src={this.props.icon['giftbox.webp']} alt='giftbox' height={65}/> 
                            ): 
                                !memberProgress.days[day].isCheckedIn && 
                                    <img src={this.props.icon['giftbox.webp']} alt='giftbox' height={90} width={80}/>
                            }

                            {day === today && 
                                memberProgress.days[day].isCheckedIn && 
                                <img src={this.props.icon['giftbox-tick.svg']} alt='giftbox' height={90} width={100}/>
                            }          
                        </>
                    )}
                </div>
            );
        }

        if (day === 6) {
            return (
                <div>
                    <div className='giftbox-label'>
                        <img src={this.props.icon['chat-bubble.svg']} alt='up to MYR5816'/>
                        <span>{t('check_in.up-to')}</span>
                    </div>
                    
                    {isDesktop ? (
                        <>
                            {day < today ? (
                                memberProgress.days[day].isCheckedIn ? 
                                    <img src={this.props.icon['giftbox2-tick.svg']} alt='giftbox' height={75}/> 
                                    : 
                                    <img src={this.props.icon['giftbox2-error.svg']} alt='giftbox' height={75}/>
                            ) : 
                                !memberProgress.days[day].isCheckedIn &&
                                    <img src={this.props.icon['giftbox-2.webp']} alt='giftbox' height={75}/>
                            }

                            {day === today &&
                                memberProgress.days[day].isCheckedIn &&
                                <img src={this.props.icon['giftbox2-tick.svg']} alt='giftbox' height={75}/>                                                             
                            }   
                        </>    
                    ) : (
                        <>
                            {day < today ? (
                                memberProgress.days[day].isCheckedIn ? 
                                    <img src={this.props.icon['giftbox2-tick.svg']} alt='giftbox' height={90} width={100}/> 
                                    : 
                                    <img src={this.props.icon['giftbox2-error.svg']} alt='giftbox' height={90} width={100}/>
                            ) : 
                                !memberProgress.days[day].isCheckedIn &&
                                    <img src={this.props.icon['giftbox-2.webp']} alt='giftbox' height={90} width={100}/>
                            }

                            {day === today &&
                                memberProgress.days[day].isCheckedIn &&
                                <img src={this.props.icon['giftbox2-tick.svg']} alt='giftbox' height={90} width={100}/>                                                              
                            }   
                        </>
                    )}
                </div>
            );
        }

        // 0 = Day 1
        // 0,1,2,4,5
        if(isDesktop) {
            return (
                <>
                    {day < today ? (
                        memberProgress.days[day].isCheckedIn ? 
                            <img src={this.props.icon['tick.svg']} alt='claimed' height={65} width={30}/> 
                            : 
                            <img src={this.props.icon['blue-circle-dot.svg']} alt='default' height={65} width={30}/>                         

                    ):                         
                        !memberProgress.days[day].isCheckedIn && 
                        <img src={this.props.icon['blue-circle-dot.svg']} alt='default' height={65} width={30}/>                         
                    }

                    {day === today && 
                        memberProgress.days[today].isCheckedIn && 
                        <img src={this.props.icon['tick.svg']} alt='claimed' height={65} width={30}/>                                             
                    }   
                </>
            )
        } else {
            return (
                <>
                    {day < today ? (
                        memberProgress.days[day].isCheckedIn ? 
                            <img src={this.props.icon['tick.svg']} alt='claimed' height={90} width={40}/>
                            : 
                            <img src={this.props.icon['blue-circle-dot.svg']} alt='default' height={65} width={30}/>                         
                    ):                         
                        !memberProgress.days[day].isCheckedIn && 
                        <img src={this.props.icon['blue-circle-dot.svg']} alt='default' height={90} width={40}/>                       
                    }

                    {day === today && 
                        memberProgress.days[today].isCheckedIn && 
                        <img src={this.props.icon['tick.svg']} alt='claimed' height={90} width={40}/>                                         
                    }              
                </>
            )
        }


    }

  render() {
    const { t } = this.props;

    return (
      <div className="mt-4 mb-5">
        {/* Progress bar */}
        <div className="position-relative">
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${this.state.progressPercent}%` }}
            />
          </div>

          {/* Icons Overlay & Days Label */}
          <div className="progress-bar-label">
            {this.props.memberProgress.days && this.props.memberProgress.days.map((_, index) => {

                return (
                    <div key={index} className={`progress-icons-label day${index}`}>
                        <div 
                            className={`mb-2 
                            ${index === this.props.today && "current"} 
                            `}
                            style={{ animationDelay: `${index * 0.3}s` }}
                        >
                            {this.renderIcon(index)}
                        </div>
                        <small
                            className={` 
                                ${ index === this.props.today && "today" } 
                                ${ index < this.props.today && "past" } 
                            `}
                        >
                            {index === this.props.today ? t('datepicker.today') : this.props.getDayLabel(index)}
                        </small>
                    </div>
                )
            })}
          </div>
        </div>
      </div>
    )
  }
}
export default (withNamespaces("translation")(CheckInStepProgress));
